/*
 * @作者: jiguijian(jiguijian@hztianque.com)
 * @描述: drugVisit 请求模块
 * @创建日期: 2020-05-13 09:13:11
 */

import { http } from '@/lib/http'
// 列表
export const getQueryData = async (payload) => {
  return await http.post('/signUp/findByPage', payload)
}
// 导出
export const exportDataDeal = async (payload) => {
  return await http.post('/signUp/exportSignUps', payload)
}
//删除
export const deleteByIds = async (payload) => {
  return await http.get('/signUp/deleteById', payload)
}
// 酒店详情
export const hotelDetails = async (payload) => {
  return await http.get('/pcHotel/findListForPC', payload)
}
// 修改
export const updateSignUpHotel = async (payload) => {
  return await http.post('/signUp/updateSignUpHotel', payload)
}